module.exports = __webpack_public_path__ + "img/trash_body.2294b39e.svg";